import { AfterViewInit, Directive, ElementRef, inject, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: `[sidenav-navigation-loading], sidenav-navigation-loading, [sidenavNavigationLoading]`,
    standalone: true,
    host: { class: 'navigation-loading' },
})
export class SidenavNavigationLoadingDirective implements OnInit
{
    @Input() lines: number = 5;

    constructor(private _renderer: Renderer2, private _el: ElementRef) {
    }

    ngOnInit() {
        for (let i = 0; i < this.lines; i++) {
            this._renderer.appendChild(this._el.nativeElement, this._renderer.createElement('span'));
        }
    }
}

@Directive({
    selector: `[sidenav-navigation-item], sidenav-navigation-item, [sidenavNavigationItem]`,
    standalone: true,
    host: { class: 'navigation-button' },
})
export class SidenavNavigationItemDirective implements OnInit, AfterViewInit
{
    @Input() description = '';
    private wrapperRef: Element;

    constructor(private _renderer: Renderer2, private _el: ElementRef) {
    }

    ngOnInit() {
        this.wrapperRef = this._el.nativeElement.querySelector('.mdc-button__label');
    }

    ngAfterViewInit() {
        const title = this.wrapperRef.textContent.trim();
        const element = this._el.nativeElement;
        this._renderer.setAttribute(element, 'aria-label', this.description.trim());
        this._renderer.setAttribute(element, 'data-intercom-target', `${title} Page Menu`);
    }
}
